export default __webpack_public_path__ + "static/1-577905739ec95b1f8199e5f02797e422.png";